import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _findIndex from "lodash/findIndex";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { unreachableWithReturn } from '../unreachable';
export var getCampusTriggerByModelTag = function getCampusTriggerByModelTag(modelTag) {
  switch (modelTag) {
    case 'learn-explain-error-prod':
    case 'learn-explain-error-staging':
    case 'learn-explain-error-candidate':
      return 'campusUser';

    case 'learn-hint-prod':
    case 'learn-hint-staging':
    case 'learn-hint-candidate':
      return 'campusUserHint';

    default:
      return unreachableWithReturn(modelTag, undefined);
  }
};
export var getModelTag = function getModelTag(isProductionEnvironment, messageType, isExperiment) {
  var environment = isProductionEnvironment ? 'prod' : 'staging';
  var tagPrefix = messageType === 'ASSISTANT' ? 'learn-explain-error' : 'learn-hint';
  return isExperiment && messageType === 'ASSISTANT' ? "".concat(tagPrefix, "-candidate") : "".concat(tagPrefix, "-").concat(environment);
};
export var appendClassSuffix = function appendClassSuffix(className, feedbackMessageType) {
  return "".concat(className, "--").concat(feedbackMessageType.toLocaleLowerCase());
};
export var calculateMaxTabs = function calculateMaxTabs(containerWidth, isHintAndSolutionVisible) {
  var baseTabListPadding = 16 * 2;
  var marginBetweenTabs = 6;
  var tabWidth = 36;
  var tabFullWidth = marginBetweenTabs + tabWidth; // solution width + 2 digit xp penalty

  var hintAndSolutionWidth = isHintAndSolutionVisible ? 222 : 0;
  return Math.floor((containerWidth + marginBetweenTabs - (baseTabListPadding + hintAndSolutionWidth)) / tabFullWidth);
};
export var getVisibleFeedbackMessages = function getVisibleFeedbackMessages(feedbackMessages, maxTabs) {
  var hintIndex = _findIndex(feedbackMessages, {
    messageType: 'HINT'
  });

  var solutionIndex = _findIndex(feedbackMessages, {
    messageType: 'SOLUTION'
  });

  var activeFeedbackIndex = _findIndex(feedbackMessages, 'isActive');

  var deduplicate = function deduplicate(arr) {
    return Array.from(new Set(arr));
  };

  var pinnableTabIndices = deduplicate([hintIndex, solutionIndex, activeFeedbackIndex]);
  var pinnedTabIndices = pinnableTabIndices.filter(function (pinnableTabIndex) {
    return pinnableTabIndex > -1;
  }).slice(0, maxTabs);
  var nbFeedbackMessages = feedbackMessages.length;
  return feedbackMessages.map(function (feedbackMessage, index) {
    return _objectSpread(_objectSpread({}, feedbackMessage), {}, {
      tabIndex: index
    });
  }).reduce(function (acc, feedbackMessage) {
    var positionFromEnd = nbFeedbackMessages - feedbackMessage.tabIndex; // acc is used because pinnedTabIndices and the last ${maxTabs} tabs
    // can intersect in different ways

    var remainingSlots = maxTabs - acc.length;

    if (pinnedTabIndices.includes(feedbackMessage.tabIndex) || // there can be more slots than tabs
    positionFromEnd <= remainingSlots) {
      return acc.concat(feedbackMessage);
    }

    return acc;
  }, []);
};